import React from "react";
import { LicenseText } from "@sscs/report/ui";
import { LicenseInsight } from "../../../types";
import styles from "./details.module.scss";
import PolicyViolations from "./PolicyViolations/PolicyViolations";

type LicenseProps = {
  issue: LicenseInsight;
};

const License = ({ issue }: LicenseProps): React.JSX.Element => {
  return (
    <div className={styles["description-and-issues-container"]}>
      <LicenseText licenseText={issue.long_description} fileName={issue.name} />
      <PolicyViolations
        violations={issue.caused_violations}
        evaluations={issue.risk_assessment_evaluation}
      />
    </div>
  );
};

export default License;
